var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-xl mx-auto mt-10" }, [
    _c("div", { staticClass: "rounded-md bg-yellow-50 p-4 mb-4" }, [
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "flex-shrink-0" }, [
          _c(
            "svg",
            {
              staticClass: "h-5 w-5 text-yellow-400",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                "aria-hidden": "true"
              }
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  d:
                    "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                  "clip-rule": "evenodd"
                }
              })
            ]
          )
        ]),
        _vm._m(0)
      ])
    ]),
    _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
      _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
        _c(
          "h3",
          { staticClass: "text-lg font-medium leading-6 text-gray-900" },
          [_vm._v(" Phone number invalid error ")]
        ),
        _c("div", { staticClass: "mt-2 max-w-xl text-sm text-gray-500" }, [
          _c("div", [
            _vm._v(
              " Recently WhatsApp has made a few changes to their WhatsApp web platform. It's not allowing to send messages to customers who are not part of their contacts. "
            ),
            _c("br"),
            _c("br"),
            _c(
              "h1",
              { staticClass: "text-sm font-medium leading-6 text-gray-900" },
              [_vm._v(" To Use Whatsapp web ")]
            ),
            _c("br"),
            _c(
              "span",
              { staticClass: "text-sm font-medium leading-6 text-gray-900" },
              [_vm._v("Step 1: Goto this link on Chrome and click clear data ")]
            ),
            _c("div", { staticClass: "mt-3 text-sm" }, [
              _c(
                "a",
                {
                  staticClass:
                    "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer",
                  attrs: {
                    href:
                      "chrome://settings/content/siteDetails?site=https://web.whatsapp.com/",
                    target: "_blank"
                  },
                  on: { click: _vm.openSettings }
                },
                [
                  _vm._v(
                    "chrome://settings/content/siteDetails?site=https://web.whatsapp.com/ "
                  )
                ]
              )
            ]),
            _c("br"),
            _c(
              "span",
              { staticClass: "text-sm font-medium leading-6 text-gray-900" },
              [
                _vm._v(
                  "Step 2: Once you clear the data open web.whatsapp.com and link your devices, "
                )
              ]
            ),
            _vm._m(1),
            _c("br"),
            _c(
              "span",
              { staticClass: "text-sm font-medium leading-6 text-gray-900" },
              [_vm._v("Step 3: Now change you sending preferences ")]
            ),
            _c("div", { staticClass: "mt-3 text-sm" }, [
              _c(
                "a",
                {
                  staticClass:
                    "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "Preference" })
                    }
                  }
                },
                [
                  _vm._v(" Open preferences "),
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v(" →")
                  ])
                ]
              )
            ]),
            _c("br"),
            _c(
              "span",
              { staticClass: "text-sm font-medium leading-6 text-gray-900" },
              [_vm._v("Step 4: Start sending messages ")]
            ),
            _c("br"),
            _c("br"),
            _c("div", [_vm._v("(or)")]),
            _c("br"),
            _c("br"),
            _c(
              "h1",
              { staticClass: "text-sm font-medium leading-6 text-gray-900" },
              [_vm._v(" To Use Whatsapp Desktop App ")]
            ),
            _c("br"),
            _c(
              "span",
              { staticClass: "text-sm font-medium leading-6 text-gray-900" },
              [_vm._v("Step 1: Install the whatsapp desktop app")]
            ),
            _c("br"),
            _vm._m(2),
            _c("br"),
            _c(
              "span",
              { staticClass: "text-sm font-medium leading-6 text-gray-900" },
              [
                _vm._v(
                  "Step 2: Once you installed the app, Please configure it here"
                )
              ]
            )
          ])
        ]),
        _c("div", { staticClass: "mt-3 text-sm" }, [
          _c(
            "a",
            {
              staticClass:
                "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "Preference" })
                }
              }
            },
            [
              _vm._v(" Open preferences "),
              _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v(" →")])
            ]
          )
        ]),
        _vm._m(3),
        _c("div", { staticClass: "mt-3 text-sm" }, [
          _c(
            "a",
            {
              staticClass:
                "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer",
              on: { click: _vm.contact }
            },
            [
              _vm._v(" Contact us "),
              _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v(" →")])
            ]
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "bg-white shadow sm:rounded-lg my-10" }, [
      _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
        _c(
          "h3",
          { staticClass: "text-lg font-medium leading-6 text-gray-900" },
          [_vm._v(" Chosen template not showing in whatsapp desktop app ")]
        ),
        _vm._m(4),
        _c("div", { staticClass: "mt-3 text-sm" }, [
          _c(
            "a",
            {
              staticClass:
                "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "Preference" })
                }
              }
            },
            [
              _vm._v(" Open preferences "),
              _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v(" →")])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "ml-3 flex-1 md:flex md:justify-between" },
      [
        _c("p", { staticClass: "text-sm text-yellow-700" }, [
          _vm._v(
            " If the customer is not on whatsapp you will get this error. If you get the error for all the checkouts / orders please follow below solutions "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3 text-sm" }, [
      _c(
        "a",
        {
          staticClass:
            "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer",
          attrs: { href: "https://web.whatsapp.com", target: "_blank" }
        },
        [
          _vm._v(" Open Whatsapp web "),
          _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v(" →")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3 text-sm" }, [
      _c(
        "a",
        {
          staticClass:
            "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer",
          attrs: {
            href:
              "https://whatsapp-desktop.en.uptodown.com/windows/download/79075839",
            target: "_blank"
          }
        },
        [_vm._v("Whatsapp Desktop For Windows")]
      ),
      _c(
        "a",
        {
          staticClass:
            "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer ml-4",
          attrs: {
            href:
              "https://whatsapp-desktop.en.uptodown.com/mac/download/79083743",
            target: "_blank"
          }
        },
        [_vm._v("Whatsapp Desktop For Mac")]
      ),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 max-w-xl text-sm text-gray-500" }, [
      _c("p", [
        _vm._v(
          " If you are still facing the error for all the checkouts / orders then please contact us "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 max-w-xl text-sm text-gray-500" }, [
      _c("div", [
        _vm._v(
          " On the newer version of the WhatsApp desktop app for windows, there is a problem where the selected template is not populated while sending the automated message. To fix this please uninstall the current app and install it from the link below "
        ),
        _c("br"),
        _c("br"),
        _c(
          "span",
          { staticClass: "text-sm font-medium leading-6 text-gray-900" },
          [_vm._v("Step 1: Uninstall the current whatsapp desktop app")]
        ),
        _c("br"),
        _c("br"),
        _c(
          "span",
          { staticClass: "text-sm font-medium leading-6 text-gray-900" },
          [_vm._v("Step 2: Install the whatsapp desktop app")]
        ),
        _c("br"),
        _c("div", { staticClass: "mt-3 text-sm" }, [
          _c(
            "a",
            {
              staticClass:
                "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer",
              attrs: {
                href:
                  "https://whatsapp-desktop.en.uptodown.com/windows/download/79075839",
                target: "_blank"
              }
            },
            [_vm._v("Whatsapp Desktop For Windows")]
          ),
          _c(
            "a",
            {
              staticClass:
                "font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer ml-4",
              attrs: {
                href:
                  "https://whatsapp-desktop.en.uptodown.com/mac/download/79083743",
                target: "_blank"
              }
            },
            [_vm._v("Whatsapp Desktop For Mac")]
          ),
          _c("br")
        ]),
        _c("br"),
        _c(
          "span",
          { staticClass: "text-sm font-medium leading-6 text-gray-900" },
          [
            _vm._v(
              "Step 3: Once you installed the app, Please configure it here"
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }